import { ModeOfTravelEnum } from "@/models/enums";
import i18n from "./i18n";


export const typeOfTravel = [
    {
        label: i18n.global.t("bookingType.Scillonian"),
        name: "Scillonian",
        value: ModeOfTravelEnum.Scillonian,
        icon: "vessel-ship",
    },
    {
        label: i18n.global.t("bookingType.Skybus"),
        name: "Skybus",
        value: ModeOfTravelEnum.Skybus,
        icon: "vessel-aircraft",
    },
    {
        label: i18n.global.t("bookingType.FlyAndSail"),
        name: "Fly and sail",
        value: ModeOfTravelEnum.FlyAndSail,
        icon: "vessel-aircraft",
    },
    {
        label: i18n.global.t("bookingType.SailAndFly"),
        name: "SailAndFly",
        value: ModeOfTravelEnum.SailAndFly,
        icon: "vessel-aircraft",
    }
];